module.exports = __webpack_public_path__ + "img/list-icon.png?7f8f6635a2d8689a478d6f21494d5580";